$(document).ready(function(){
    $(document).on("click",".block__our-promises-js-videosound",function(){
      if($(this).hasClass("active")){
        $(this).removeClass("active")
        $(this).parents(".block__our-promises-images").find("video").prop('muted', false);
      }else{
        $(this).addClass("active")
        $(this).parents(".block__our-promises-images").find("video").prop('muted', true);
      }
    });
  
    $(document).on("click",".block__our-promises-js-videoplay-pause",function(){
      if(!$(this).hasClass("active")){
        $(this).addClass("active")
        $(this).parents(".block__our-promises-images").find("video").get(0).pause();
      }else{
        $(this).removeClass("active")
        $(this).parents(".block__our-promises-images").find("video").get(0).play();
      }
    });
});